var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldBlend2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97 2c-3.87 0-7 3.13-7 7 0 3.55 2.64 6.48 6.07 6.93a6.397 6.397 0 0 0 1.81.01l-.38-.38a.754.754 0 0 1 0-1.06c.29-.3.77-.3 1.06 0l.757.756a.5.5 0 0 0 .579.093c.685-.346 1.186-.649 1.505-.909l-.9-.89a.745.745 0 0 1 0-1.06c.29-.29.76-.3 1.06-.01l.472.467a.5.5 0 0 0 .77-.082c.344-.526.58-.957.708-1.295l-1.01-1.01a.754.754 0 0 1 0-1.06c.29-.3.77-.3 1.06 0a.25.25 0 0 0 .427-.16 5.654 5.654 0 0 0-.057-1.27A6.986 6.986 0 0 0 8.97 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.97 22c-3.18 0-5.87-2.12-6.71-5.04.22.03.46.04.71.04.35 0 .68-.02 1.02-.07l.505-.068a.5.5 0 0 1 .42.142l.525.525c.15.15.34.22.53.22.2 0 .39-.07.53-.22.3-.29.3-.77 0-1.06a.212.212 0 0 1 .047-.336c.716-.399 1.23-.73 1.543-.994l.81.8c.15.14.34.22.53.22s.39-.08.53-.23c.29-.29.29-.77-.01-1.06l-.498-.491a.5.5 0 0 1-.058-.642c.418-.6.704-1.065.856-1.397l.19.19c.15.15.34.22.53.22.2 0 .39-.07.53-.22.3-.29.3-.77 0-1.06l-.526-.525a.5.5 0 0 1-.142-.42l.068-.505c.05-.34.07-.67.07-1.02 0-.25-.01-.49-.04-.71A6.99 6.99 0 0 1 21.97 15c0 3.87-3.13 7-7 7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldBlend2);
export default __webpack_public_path__ + "static/media/vuesax-bold-blend-2.a508369cd4f3a96de97e9a247ece7c4d.svg";
export { ForwardRef as ReactComponent };